var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPhoneSimple = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.04.5B_Edit-location---General-/-Address-Map---Urban-Sports-Club",
    transform: "translate(-63.000000, -1264.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(42.000000, 780.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cells-/-Small-Image-Copy-3",
    transform: "translate(0.000000, 467.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Location-/-Black-Background",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20275,7 L9.20275,7 C6.26575,9.948 6.26575,14.729 9.20275,17.677 L11.61975,20.104 C14.55675,23.053 19.31675,23.053 22.25275,20.104 L18.39075,16.227 L17.23475,17.388 C16.16775,18.459 14.43875,18.459 13.37275,17.388 L11.90775,15.917 C10.84075,14.847 10.84075,13.11 11.90775,12.039 L13.06375,10.878 L9.20275,7 Z",
    id: "Stroke-1"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhoneSimple, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phoneSimple.b18e6b51.svg";
export { ForwardRef as ReactComponent };